import plugin_vue3_A0OWXRrUgq from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import revive_payload_client_4sVQNw7RlN from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import payload_client_yVLowv6hDl from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/app/plugins/payload.client.js";
import deepLinks_QjB9r6Oao0 from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/deepLinks.ts";
import firebase_client_zXNDa0wxFH from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/firebase.client.ts";
import global_components_PEc2PKHunz from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/global-components.ts";
import i18n_VfGcjrvSkj from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/i18n.ts";
import sentry_client_shVUlIjFLk from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/sentry.client.ts";
import tenant_client_xEoudXRql6 from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/plugins/tenant.client.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  payload_client_yVLowv6hDl,
  deepLinks_QjB9r6Oao0,
  firebase_client_zXNDa0wxFH,
  global_components_PEc2PKHunz,
  i18n_VfGcjrvSkj,
  sentry_client_shVUlIjFLk,
  tenant_client_xEoudXRql6
]